import { render, staticRenderFns } from "./backend-role.vue?vue&type=template&id=00ce1dad&"
import script from "./backend-role.vue?vue&type=script&lang=js&"
export * from "./backend-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports